// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import { Typography, Link } from '@mui/material';
import { Box, useTheme } from '@mui/system';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import stylesDef from './styles';

// Set by CreateOrgThunk when it redirects here, so the page can echo the address the link went to
interface SignUpSuccessLocationState {
  email?: string;
}

// This component renders the "Check your email" page shown once a sign up has been submitted
const SignUpSuccess = () => {
  const theme = useTheme();
  const styles = stylesDef(theme);
  const locationState = useLocation().state as SignUpSuccessLocationState | null;
  const email = locationState?.email;
  return (
    <Box sx={styles.root}>
      <Box sx={styles.badge}>
        <MailOutlineIcon sx={styles.badgeIcon} />
      </Box>
      <Typography sx={styles.header} variant="h2">
        Check your email
      </Typography>
      <Typography sx={styles.details}>
        {email ? 'We sent a confirmation link to' : 'We sent you a confirmation link.'}
      </Typography>
      {email && (
        <Box sx={styles.emailChip}>
          {email}
        </Box>
      )}
      <Typography sx={styles.helpText} variant="body2">
        Click the link in that email to activate your account. If you don’t see it in a few minutes, check your spam folder.
      </Typography>
      <Link component={RouterLink} sx={styles.link} to="/">
        Go to Log in
      </Link>
    </Box>
  );
};

export default SignUpSuccess;
